import React, { useContext, useEffect, useState } from "react";
import EmotionalIntelligence from "./EmotionalIntelligence";
import { Divider } from "antd";
import BeckAnxiety from "./BeckAnxiety";
import BeckDepression from "./BeckDepression";
import { PsychologistReviewContext } from "../../Psychologist/Review/PsychologistReviewProvider";
import PsychologistMocaScale from "./PsychologistMocaScale";

const PsychologistScales = ({ form }) => {
  const [refresh, setRefresh] = useState(false);
  const { formData } = useContext(PsychologistReviewContext);
  useEffect(() => {
    form.setFieldsValue(formData?.scales);
    setTimeout(() => setRefresh((prev) => !prev), 1000);
  }, [formData]);
  return (
    <>
      <EmotionalIntelligence context={PsychologistReviewContext} form={form} />
      <Divider />
      <BeckAnxiety context={PsychologistReviewContext} form={form} />
      <Divider />
      <BeckDepression context={PsychologistReviewContext} form={form} />
      <Divider />
      <PsychologistMocaScale context={PsychologistReviewContext} form={form} />
    </>
  );
};

export default PsychologistScales;
